﻿import { DrawingEngine } from './DrawingEngine.js';
import { ProductMaterialLoader } from './ProductMaterialLoader.js';

export class DrawingEngine2020 extends DrawingEngine {
  constructor(name, options) {
    super(name, options);
    // This is a default, the callback should be set by the owner:
    this.getFinishName = finishId => finishId;
    this.loader = options.sharedLoader || new ProductMaterialLoader(this.getMaterialImagesFolder(),
      finishId => this.getFinishName(finishId));
    this.lowRes = 'low-res';
    this.highRes = 'high-res';
  }

  static canShareLoader() { return true; }

  getMaterialImagesFolder() {
    return this.finishImagesBaseUrl;
  }

  /**
   * Pre-loads material images
   * @param {any} allMaterials Our global list of known materials
   * @param {any} materialIdsToLoad Material id's of the images we want to preload now.
   * @param {string} resolution Indicates which images to load, low/high resolution etc. The param value
   * should be the name of the folder containing resolution specific images, e.g. 'low-res' or 'high-res'.
   * @return {array of material object} The materials which are being loaded.
   */
  async loadMaterials(allMaterials, materialIdsToLoad, resolution) {
    this.loader.folderRelativePath = this.getMaterialImagesFolder();
    return await this.loader.load(allMaterials, materialIdsToLoad, resolution);
    // Note, loaded material images are also in the loader.loadedMaterials property.
  }

  /**
   * Loads the image for a single material.
   * @return {bool} True if the material was loaded now, false if it was already loaded (loaded earlier).
   */
  async loadSingleMaterial(material, loadHighResAsWell, onHisResImgLoaded) {
    this.loader.folderRelativePath = this.getMaterialImagesFolder();
    let resolution = this.lowRes;
    console.log(`Awaiting engine.loadSingleMaterial(${material.id}, ${resolution})...`);
    // Wait while loading the low-res image:
    const wasLoadedNow = await this.loader.loadSingleMaterial(material, resolution);
    console.log(`${wasLoadedNow ? material.id : 'No'} low-res material loaded!`);
    if (loadHighResAsWell) {
      resolution = this.highRes;
      // Load the high-res image asynchronously:
      console.log(`Async engine.loadSingleMaterial(${material.id}, ${resolution})...`);
      this.loader.loadSingleMaterial(material, resolution)
        .then(loadedNow => {
          console.log(`${loadedNow ? material.id : 'No'} high-res material async-loaded!`);
          if (loadedNow) {
            this.setCurrentSingleMaterialImageResolution(material, resolution);
            if (onHisResImgLoaded) {
              onHisResImgLoaded(material);
            }
          }
        });
      console.log(`Continuing while the ${resolution} material is being loaded...`);
    }
    return wasLoadedNow;
  }

  /** Updates the "current" property on each item in the materials array parameter. */
  setCurrentMaterialImageResolution(materials, resolution) {
    materials.forEach(material => {
      material.current = material[resolution];
    })
  }

  /** Updates the "current" property on the material parameter. */
  setCurrentSingleMaterialImageResolution(material, resolution) {
    material.current = material[resolution];
  }

}
